module.exports = __webpack_public_path__ + "static/media/iconGaceta.fcbd370e.svg";